import React from 'react';

import {
  BugsResolvedTextStyled,
  BugsSummaryTextStyled,
} from './ReportColumn.styled';

type Props = {
  bugsSummary: { resolvedPercent: number };
};

export default function ClosedPercent({ bugsSummary }: Props): JSX.Element {
  const text = `${bugsSummary.resolvedPercent}% resolved`;

  if (bugsSummary.resolvedPercent >= 80) {
    return <BugsResolvedTextStyled>{text}</BugsResolvedTextStyled>;
  }

  return <BugsSummaryTextStyled>{text}</BugsSummaryTextStyled>;
}
